/* tslint:disable */
/* eslint-disable */

/**
 * 0 = EnDemande
 * 1 = Validee
 * 2 = Planifiee
 * 3 = Effectuee
 * 4 = Annulee
 */
export enum StatutIntervention {
  EnDemande = 0,
  Validee = 1,
  Planifiee = 2,
  Effectuee = 3,
  Annulee = 4
}
